import { createFileRoute } from '@tanstack/react-router';

/**
 * The parent of everything under `/people/<ref>` — and deliberately nothing else.
 *
 * It has NO component, which is the entire point. Under flat file routing
 * `people.$ref.edit.tsx` nests beneath a `/people/$ref` route whether or not one is written,
 * so this file exists to say what that route is: a passthrough. A route with no component
 * renders `<Outlet />` by default, so each child renders alone.
 *
 * What used to be here was the record page. That made the record the edit page's parent, and a
 * parent without an outlet swallows its children — `/people/PE000003/edit` matched the edit
 * route correctly and then painted the read-only record over the top of it, so Edit looked
 * like it simply did not work. The record now lives in `people.$ref.index.tsx`.
 *
 * No `beforeLoad` here either. Ref normalisation belongs to each child, because they redirect
 * to different paths — a parent that sent every ref to `/people/$ref` would bounce anyone
 * trying to edit one straight back out of the form.
 *
 * `routing.test.ts` pins the rule for every route: no route may have both children and a
 * component.
 */
export const Route = createFileRoute('/people/$ref')({});
